export default "__VITE_ASSET__BtaAMGNP__"